class DocumentoAnexosUrlBuilder {
	constructor(tipo) {
		this.PATH = tipo.path
	}

	getUrlInserir() {
		return `api/${this.PATH}/documentos/anexo`
	}
}

export default DocumentoAnexosUrlBuilder
